import React, { useEffect } from "react";
import Header from "./Header";
import { Outlet, useSearchParams, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import { message } from "antd";

const Root = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");

    if (token) {
      localStorage.setItem("token", token);
      message.success("Successfully logged in with Google!");
      navigate("/form_page", { replace: true });
    } else if (error) {
      message.error(decodeURIComponent(error));
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, navigate, setSearchParams]);

  return (
    <div className="min-h-screen flex flex-col relative bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Root;
